/**
 * Get default dispatch location ID from available locations
 * Condition A: Returns location with default=true if found
 * Condition B: Returns first available location if no default is set
 *
 * @param locations - Array of dispatch locations with id, name, and optional default flag
 * @returns The ID of the default location, or null if no locations available
 */
export function getDefaultDispatchLocationId(
  locations: Array<{ id: number; name?: string | null; default?: boolean | null }>
): number | null {
  if (!locations.length) return null;

  const defaultLocation = locations.find((loc) => loc.default === true);
  return defaultLocation?.id ?? locations[0]?.id ?? null;
}
